import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class WhiteLabelAdminAPI {
  constructor(http) {
    this.http = http;
  }

  create( data, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });


    this.http.post('api/admin/whitelabel/create', data)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel_id")) {
                       
                        successCallback(json.whitelabel_id);
                    }


                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

  save(data, files, token, successCallback, errorCallback) {
    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    let formData = new FormData();
    formData.append('whitelabel', JSON.stringify(data));
  
    for(var [fileType, file] of files) {
      formData.append(fileType, file);
    }

    http.post('api/admin/whitelabel/save', formData)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel")) {
                       
                        successCallback(json.whitelabel);
                    }

                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

  getWhiteLabelList(page, limit, sortBy, sortDir, search, parent_id = null, token, successCallback, errorCallback) {

    console.log("parent id in services", parent_id);
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    let queryString = `?page=${page}&limit=${limit}&sortBy=${sortBy}&sortDir=${sortDir}`;

    if(parent_id) {
      queryString += `&parent_id=${parent_id}`;
    }
    if(search) {
      queryString += `&search=${search}`;
    }

    this.http.get('api/admin/whitelabel/getWhiteLabelList' + queryString)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('users')) {
            successCallback(json.users);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }



  generateApiSecretKey(wl_id, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });
    // whitelabelreseller/generateSecretAccessKey?wl_id=22
    this.http.get(`api/admin/whitelabelreseller/generateSecretAccessKey?wl_id=${wl_id}`)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('key')) {
            successCallback(json.key);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }




  getWhiteLabelResellerList(page, limit, sortBy, sortDir, search, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    let queryString = `?page=${page}&limit=${limit}&sortBy=${sortBy}&sortDir=${sortDir}`;

    if(search) {
      queryString += `&search=${search}`;
    }

    this.http.get('api/admin/whitelabelreseller/getWhiteLabelResellerList' + queryString)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('users')) {
            successCallback(json.users);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }  

  getWhiteLabelData(id, token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    this.http.get('api/admin/whitelabel/getWhiteLabelData/' + id)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabel')) {
            successCallback(json.whitelabel);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  // generateApiSecretKey(wl_id, token, successCallback, errorCallback) {
  //   this.http = this.http.configure(x => {
  //     x.withHeader('Content-Type', 'application/json')
  //      .withHeader('Authorization', token);
  //   });
  //   // whitelabelreseller/generateSecretAccessKey?wl_id=22
  //   this.http.get(`api/admin/whitelabelreseller/generateSecretAccessKey?wl_id=${wl_id}`)
  //     .then(data => {
  //       if (data.isSuccess) {
  //         let json = JSON.parse(data.response);

  //         if (json.hasOwnProperty('key')) {
  //           successCallback(json.key);
  //         }

  //         if (json.hasOwnProperty('error')) {
  //           errorCallback(json.error);
  //         }
  //       } else {
  //         errorCallback(data.statusText);
  //       }
  //     });
  // }

  getWhiteLabelStatusList(token, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
      x.withHeader('Content-Type', 'application/json')
       .withHeader('Authorization', token);
    });

    this.http.get('api/admin/whitelabel/getWhiteLabelStatusList')
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabelStatusList')) {
            successCallback(json.whitelabelStatusList);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  deleteAssets(id, token, successCallback, errorCallback) {
    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    http.post(`api/admin/whitelabel/deleteAssets/${id}`)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabel')) {
            successCallback(json.whitelabel);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }

  transferUsers(id, token, successCallback, errorCallback) {
    let http = new HttpClient().configure(x => {
      x.withHeader('Authorization', token);
    });

    http.post(`api/admin/whitelabel/transferUsers/${id}`)
      .then(data => {
        if (data.isSuccess) {
          let json = JSON.parse(data.response);

          if (json.hasOwnProperty('whitelabel')) {
            successCallback(json.whitelabel);
          }

          if (json.hasOwnProperty('error')) {
            errorCallback(json.error);
          }
        } else {
          errorCallback(data.statusText);
        }
      });
  }



}
